interface WidgetParams {
  widgetId?: string;
  parentUrl?: string;
  roomId?: string;
  userId?: string;
  deviceId?: string;
  baseUrl?: string;
  spaceRoomId?: string;
  chatRoomId?: string;
  accessToken?: string;
}

export const getUrlParams = (): WidgetParams => {
  // Use hash fragment if present, otherwise fallback to search
  const paramString = window.location.hash.startsWith('#?')
    ? window.location.hash.substring(2)
    : window.location.search.startsWith('?')
    ? window.location.search.substring(1)
    : '';

  const params = new URLSearchParams(paramString);

  const get = (key: string): string | undefined => {
    const v = params.get(key);
    return v === null ? undefined : v;
  };

  const result: WidgetParams = {
    widgetId: get('widgetId'),
    parentUrl: get('parentUrl'),
    roomId: get('roomId'),
    userId: get('userId'),
    deviceId: get('deviceId'),
    baseUrl: get('baseUrl'),
    spaceRoomId: get('space'),
    chatRoomId: get('chatRoomId'),
    accessToken: get('accessToken'),
  };

  return result;
};

export const isWidget = (): boolean => {
  const { widgetId } = getUrlParams();

  return !!widgetId;
};
